<template>
  <div class="flex min-h-screen flex-col justify-center bg-background py-12 sm:px-6 lg:px-8">
    <div class="max-w-[1440px] mx-auto w-full">
      <div class="sm:mx-auto sm:w-full sm:max-w-md">
        <div class="text-center">
          <NuxtLink to="/">
            <img src="@/assets/img/loop-letters-logo.svg" class="h-[75px] w-[75px] mx-auto" alt="Logo" />
          </NuxtLink>
          <h2 class="mt-3 text-center text-3xl font-bold tracking-tight text-text">
            {{ $appTitle }}
          </h2>
        </div>
      </div>

      <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div class="bg-background-card px-6 py-8 shadow sm:rounded-lg sm:px-10">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const { $appTitle } = useNuxtApp();
</script> 